import { api } from './client';
import { readAccess } from '@/types/flightAccess';
import type { FlightAccess } from '@/types/flightAccess';

/**
 * The signed-in user's own flight access — the one that APPLIES.
 *
 * In `lib/` rather than in the users feature because the app shell and several
 * screens read it, and a feature may not import from another feature. The calls that
 * READ AND WRITE other people's access are administrator-only and live with the user
 * screen, in `features/users/api.ts`.
 *
 * Any signed-in role may call this, and only for themselves: there is no id in the
 * request, the account comes from the token. For an administrator it is always
 * `restricted: false`, whatever is stored for them.
 *
 * `selfId` is not sent. It only fills `userId` if the response leaves it out.
 */
export const fetchMyFlightAccess = (selfId: number, signal?: AbortSignal): Promise<FlightAccess> =>
  api
    .get<unknown>('/user/me/flight-access', undefined, signal)
    .then((response) => readAccess(response, selfId));
